import React from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";

const styles = {
  chip: {
    backgroundColor: "action.hover",
    borderRadius: 1,
  },
  rackChip: {
    backgroundColor: "action.hover",
    borderRadius: 1,
    fontWeight: 500,
  },
};

export default function ItemActions({ value, warehouses = [] }) {
  const itemWarehouses = value.rackLocations
    .map(location => location.warehouse)
    .map(warehouseId => warehouses.find(w => w.warehouseId === warehouseId))
    .filter(Boolean);

  const rackLocationLabels = (value?.rackLocations || []).map(rl => {
    const locationNames = (rl.warehouse_locations || []).map(loc => loc.location_name).filter(Boolean);
    if (locationNames.length === 0) return null;
    const qty = rl.sub_qty;
    return qty ? `${locationNames.join(", ")} (${qty})` : locationNames.join(", ");
  }).filter(Boolean);

  const mobileLocationLabels = [
    ...new Set(
      (value?.rackLocations || [])
        .map(rl => rl.mobile_warehouse_location?.location_name)
        .filter(Boolean)
    ),
  ];

  const showWarehouseNames = warehouses.length > 1;

  return (
    <Box display="flex" flexDirection="column" gap={0.5} alignItems="flex-end">
      {rackLocationLabels.length > 0 && (
        <Box display="flex" gap={0.5} flexWrap="wrap" justifyContent="flex-end">
          {rackLocationLabels.map((label, index) => (
            <Chip key={`rack-${value.id}-${index}`} label={label} size="small" sx={styles.rackChip} />
          ))}
        </Box>
      )}
      {mobileLocationLabels.length > 0 && (
        <Box display="flex" flexDirection="column" alignItems="flex-end" gap={0.25}>
          {mobileLocationLabels.map((label, index) => (
            <Box key={`mobile-${index}`} fontSize="0.75rem" color="text.secondary">
              {label}
            </Box>
          ))}
        </Box>
      )}
      {showWarehouseNames && itemWarehouses.length > 0 && (
        <Box display="flex" gap={0.5} flexWrap="wrap" justifyContent="flex-end">
          {itemWarehouses.map((warehouse, index) => (
            <Chip key={`warehouse-${index}`} label={warehouse.name} size="small" sx={styles.chip} />
          ))}
        </Box>
      )}
    </Box>
  );
}


